import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import Navigation from '../Navigation/Navigation.js'
import NoContent from '../NoContent/NoContent.js'
import BewilligungAbklaeren from '../BewilligungAbklaeren/BewilligungAbklaeren.js'

export default class MainView extends WebComponent {

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.oldChild = null
    this.navigationListener = e => {
      // split is used if we have vertical submenu navigation
      this.loadView(e.detail)
    }
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)

    this.loadView(getNavigationHash())
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  loadView(linkName) {
    if (isEmpty(linkName)) {
      this.redirectToDefault()
    } else {
      const newChild = this.returnNewChild(linkName)
      if (this.oldChild) {
        this.root.replaceChild(newChild, this.oldChild)
      } else {
        this.root.appendChild(newChild)
      }

      this.oldChild = newChild
    }
  }

  returnNewChild(linkName) { //NOSONAR
    switch (linkName) {
      case 'bewilligung-abklaeren':
      case '':
          return new BewilligungAbklaeren()
      default:
        return new NoContent()
    }
  }

  redirectToDefault() {
    navigate({to: 'bewilligung-abklaeren'})
  }

  getTemplate() {
    return html`bewilligung-frontend-main-view`
  }
}

customElements.define('bewilligung-frontend-main-view', MainView)
